/* Native Shopify Cart API; no order creation, lead transport or tracking replacement. */
(() => {
  const dialog = document.querySelector('#hlx-cart-drawer');
  if (!dialog || !dialog.showModal) return;
  const body = dialog.querySelector('[data-hlx-drawer-body]');
  const error = dialog.querySelector('[data-hlx-cart-error]');
  const labels = JSON.parse(dialog.querySelector('[data-hlx-cart-labels]').textContent);
  const icons = dialog.querySelector('template').content;
  const icon = name => icons.querySelector(`.hlx-icon-${name}`).outerHTML;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const categories = JSON.parse(document.querySelector('#hlx-recent-card-data')?.textContent || '{}');
  const root = dialog.dataset.rootUrl.replace(/\/?$/, '/');
  const money = (cents, currency) => {
    const code = currency || dialog.dataset.currency;
    return new Intl.NumberFormat(dialog.dataset.locale || document.documentElement.lang || undefined, {style:'currency', currency:code})
      .formatToParts(cents / 100).map(part => part.type === 'currency' && code === dialog.dataset.currency && dialog.dataset.currencySymbol
        ? dialog.dataset.currencySymbol : part.value).join('');
  };
  let cart = null, busy = false, changed = false, opener = null;
  const addedMessage = dialog.querySelector('[data-hlx-cart-added]');
  const kicker = dialog.querySelector('[data-hlx-drawer-kicker]');
  const setBusy = value => {
    busy = value;
    body.setAttribute('aria-busy', String(value));
    body.querySelectorAll('button,input').forEach(node => node.disabled = value);
  };
  async function request(path, data) {
    const response = await fetch(root + path, {credentials:'same-origin', headers:{Accept:'application/json', ...(data ? {'Content-Type':'application/json'} : {})}, ...(data ? {method:'POST', body:JSON.stringify(data)} : {} )});
    const payload = await response.json();
    if (!response.ok) throw new Error(payload.description || payload.message || labels.error);
    return payload;
  }
  const showError = message => { error.textContent = message; error.hidden = false; };
  function render(next) {
    cart = next;
    dialog.querySelector('[data-hlx-drawer-count]').textContent = `(${cart.item_count})`;
    document.querySelectorAll('.hlx-cart-count').forEach(node => node.textContent = cart.item_count);
    if (!cart.items.length) {
      body.innerHTML = `<div class="hlx-drawer-empty"><h3>${escape(labels.empty)}</h3><p>${escape(labels.choose)}</p><a class="hlx-drawer-button" href="${escape(dialog.dataset.catalogUrl)}">${escape(labels.explore)}</a></div>`;
      return;
    }
    body.innerHTML = `<div class="hlx-drawer-lines">${cart.items.map(line => `<article class="hlx-drawer-line" data-key="${escape(line.key)}"><a class="hlx-drawer-image" href="${escape(line.url)}">${line.image ? `<img src="${escape(line.image)}" alt="${escape(line.product_title)}" width="105" height="105">` : ''}</a><div>${categories[line.url.split('?')[0]] ? `<span class="hlx-drawer-category">${escape(categories[line.url.split('?')[0]].category)}</span>` : ''}<a href="${escape(line.url)}"><h3>${escape(line.product_title)}</h3></a>${line.variant_title && line.variant_title !== 'Default Title' ? `<span class="hlx-drawer-variant">${escape(line.variant_title)}</span>` : ''}<span class="hlx-drawer-unit">${escape(money(line.final_price,cart.currency))} / ${escape(labels.unit)}</span><div class="hlx-drawer-line-actions"><div class="hlx-drawer-quantity"><button type="button" data-step="-1" aria-label="${escape(labels.quantity)} − ${escape(line.product_title)}">${icon('minus')}</button><input type="number" min="0" step="1" inputmode="numeric" value="${line.quantity}" aria-label="${escape(labels.quantity)}: ${escape(line.product_title)}"><button type="button" data-step="1" aria-label="${escape(labels.quantity)} + ${escape(line.product_title)}">${icon('plus')}</button></div><button type="button" data-remove aria-label="${escape(labels.remove)} ${escape(line.product_title)}">${escape(labels.remove)}</button></div></div><strong>${escape(money(line.final_line_price,cart.currency))}</strong></article>`).join('')}</div><div class="hlx-drawer-footer"><div><strong>${escape(labels.total)}</strong><b>${escape(money(cart.total_price,cart.currency))}</b></div><form action="${escape(dialog.dataset.cartUrl)}" method="post"><button class="hlx-drawer-button" type="submit" name="checkout">${icon('lock')}<span>${escape(labels.checkout)}</span>${icon('arrow')}</button></form><a class="hlx-drawer-button secondary" href="${escape(dialog.dataset.cartUrl)}">${escape(labels.view)}</a><button type="button" class="hlx-drawer-continue" data-hlx-cart-close>${escape(labels.continue)}</button></div>`;
  }
  async function refresh() {
    if (busy) return;
    error.hidden = true;
    setBusy(true);
    try { render(await request('cart.js')); }
    catch (e) { showError(e.message || labels.error); }
    finally { setBusy(false); }
  }
  function open(trigger, addedTitle = '') {
    opener = trigger;
    if (kicker) kicker.textContent = addedTitle ? labels.added : labels.kicker;
    if (addedMessage) { addedMessage.hidden = !addedTitle; addedMessage.querySelector('span').textContent = addedTitle; }
    body.textContent = labels.loading;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('hlx-drawer-open');
  }
  window.addEventListener('submit', async event => {
    const form = event.target, submitter = event.submitter;
    if (event.defaultPrevented || !form.matches('#footer-product-form,form[data-type="add-to-cart-form"]')) return;
    if (submitter && !submitter.matches('[data-add-to-cart],#footer-product-form button[type="submit"]')) return;
    const action = new URL(form.action, location.href);
    if (action.origin !== location.origin || !action.pathname.endsWith('/cart/add')) return;
    if (busy) { event.preventDefault(); return; }
    // Preserve external quantity controls, selected variant, properties and Shopify fields.
    const data = submitter ? new FormData(form, submitter) : new FormData(form);
    event.preventDefault();
    const buttons = [...document.querySelectorAll('[data-add-to-cart],#footer-product-form button[type="submit"]')].filter(button => !button.disabled);
    buttons.forEach(button => button.disabled = true);
    open(submitter); error.hidden = true; setBusy(true);
    try {
      const response = await fetch(action.pathname + '.js', {method:'POST',body:data,credentials:'same-origin',headers:{Accept:'application/json'}});
      const added = await response.json();
      if (!response.ok) throw new Error(added.description || added.message || labels.error);
      if (kicker) kicker.textContent = labels.added;
      if (addedMessage) { addedMessage.hidden = false; addedMessage.querySelector('span').textContent = added.product_title || added.title || ''; }
      render(await request('cart.js'));
    } catch (e) {
      // Never automatically retry an add: a lost response may already have changed the cart.
      showError(e.message || labels.error);
      try { render(await request('cart.js')); } catch (_) { body.textContent = labels.error; }
    } finally { buttons.forEach(button => button.disabled = false); setBusy(false); }
  }, true);
  async function change(key, quantity) {
    if (busy || !Number.isSafeInteger(quantity) || quantity < 0) return;
    const focusIndex = [...body.querySelectorAll('button,input')].indexOf(document.activeElement);
    error.hidden = true; setBusy(true);
    try { render(await request('cart/change.js', {id:key, quantity})); changed = true; }
    catch (e) { showError(e.message || labels.error); if (cart) render(cart); }
    finally {
      setBusy(false);
      if (dialog.open) body.querySelectorAll('button,input')[focusIndex]?.focus();
      else if (changed && !busy && location.pathname.replace(/\/$/,'') === dialog.dataset.cartUrl.replace(/\/$/,'')) location.reload();
    }
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-hlx-cart-open]');
    if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); open(trigger); refresh();
  });
  dialog.addEventListener('click', event => {
    if (event.target.closest('[data-hlx-cart-close]')) { dialog.close(); return; }
    if (event.target === dialog) { const r=dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right) dialog.close(); }
    const line = event.target.closest('[data-key]');
    if (!line || !cart || busy) return;
    const item = cart.items.find(item => item.key === line.dataset.key);
    if (event.target.closest('[data-remove]')) change(item.key, 0);
    const step = event.target.closest('[data-step]');
    if (step) change(item.key, Math.max(0,item.quantity + Number(step.dataset.step)));
  });
  dialog.addEventListener('change', event => {
    if (event.target.matches('.hlx-drawer-quantity input')) {
      const quantity = Number(event.target.value);
      if (event.target.value.trim() && Number.isSafeInteger(quantity) && quantity >= 0) change(event.target.closest('[data-key]').dataset.key, quantity);
      else if (cart) render(cart);
    }
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('hlx-drawer-open'); opener?.focus();
    if (changed && !busy && location.pathname.replace(/\/$/,'') === dialog.dataset.cartUrl.replace(/\/$/,'')) location.reload();
  });
})();
